import { render } from "./StudentProjectDetails.vue?vue&type=template&id=0939af2b&scoped=true"
import script from "./StudentProjectDetails.vue?vue&type=script&lang=js"
export * from "./StudentProjectDetails.vue?vue&type=script&lang=js"

import "./StudentProjectDetails.vue?vue&type=style&index=0&id=0939af2b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0939af2b"

export default script